import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p381044443275448320',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
